import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DropzoneArea = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'isDragging' && prop !== 'hasFile',
})<{ isDragging: boolean; hasFile: boolean }>(({ theme, isDragging, hasFile }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	gap: theme.spacing(1.5),
	padding: theme.spacing(4),
	marginTop: theme.spacing(3),
	marginBottom: theme.spacing(3),
	border: `2px dashed ${isDragging ? theme.palette.primary.main : hasFile ? theme.palette.success.main : theme.palette.divider}`,
	borderRadius: theme.shape.borderRadius,
	backgroundColor: isDragging
		? theme.palette.primary.main + '0D'
		: hasFile
		? theme.palette.success.main + '0D'
		: theme.palette.background.default,
	cursor: 'pointer',
	transition: 'all 0.2s ease',
	'&:hover': {
		borderColor: theme.palette.primary.main,
		backgroundColor: theme.palette.primary.main + '0D',
	},
}));

export const DropzoneIconWrapper = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'hasFile',
})<{ hasFile: boolean }>(({ theme, hasFile }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: 56,
	height: 56,
	borderRadius: '50%',
	backgroundColor: hasFile ? theme.palette.success.main + '1A' : theme.palette.primary.main + '1A',
	color: hasFile ? theme.palette.success.main : theme.palette.primary.main,
}));

export const DropzoneHint = styled(Typography)(({ theme }) => ({
	fontSize: '0.75rem',
	color: theme.palette.text.disabled,
	textAlign: 'center',
}));

export const FileTypeChip = styled(Box)(({ theme }) => ({
	display: 'inline-flex',
	alignItems: 'center',
	gap: theme.spacing(0.5),
	padding: theme.spacing(0.25, 1),
	borderRadius: 12,
	fontSize: '0.7rem',
	fontWeight: 700,
	backgroundColor: theme.palette.primary.main + '1A',
	color: theme.palette.primary.main,
	textTransform: 'uppercase',
	letterSpacing: '0.05em',
}));

export const ModeSwitchContainer = styled(Box)(({ theme }) => ({
	marginTop: theme.spacing(2.5),
	marginBottom: theme.spacing(0.5),
	borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const UrlFieldsContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(2),
	marginTop: theme.spacing(3),
	marginBottom: theme.spacing(3),
}));

export const ModalActions = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'flex-end',
	gap: theme.spacing(1.5),
	padding: theme.spacing(1, 3, 3),
}));
